import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import useI18N from "../hooks/useI18N";
import { AppStore, Logo, PlayStore } from "../shared/icon";

const APPLE_STORE_URL =
  "https://apps.apple.com/us/app/sooq-al-thahab/id6744402869";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.sooqalthahab.mobile&pli=1";

const RediectionToMobile = () => {
  const { t } = useI18N();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        px: 2,
        bgcolor: "background.default",
        color: "text.primary",
      }}
    >
      <Logo />

      <Box
        component="h1"
        sx={{
          fontWeight: 700,
          fontSize: { xs: "2rem", sm: "2.5rem" },
          mb: 2,
          textAlign: "center",
        }}
      >
        {t("redirection-title")}
      </Box>
      <Box
        component="p"
        sx={{
          textAlign: "center",
          mb: 5,
          maxWidth: 400,
          fontSize: { xs: "1rem", sm: "1.125rem" },
          color: "text.secondary",
        }}
      >
        {t("redirection-subtitle")}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: 2.5,
          width: "100%",
          maxWidth: 440,
          justifyContent: "center",
        }}
      >
        <Button
          href={APPLE_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: { xs: 3, sm: "10px" },
            border: "1px solid #666",
            borderRadius: "6px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {t("app-store")} <AppStore height={40} width={40} />
        </Button>
        <Button
          href={PLAY_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: { xs: 3, sm: "10px" },
            border: "1px solid #666",
            borderRadius: "6px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {t("play-store")} <PlayStore height={40} width={40} />
        </Button>
      </Box>
    </Box>
  );
};

export default RediectionToMobile;
